import { configureStore } from '@reduxjs/toolkit';
import { slice } from './load_data';

export const store = configureStore({reducer:slice.reducer});

